import privateRoutes from "src/routes/private-routes";
import publicRoutes from "src/routes/public-routes";

// exclude the landing page "/international-transaction"
export const FLIP_GLOBE_ROUTES = [
  privateRoutes.internationalTransactionUploadExcel.path,
  privateRoutes.internationalTransactionMultiInput.path,
  privateRoutes.internationalTransactionReview.path,
  privateRoutes.internationalTransactionSummary.path,
  privateRoutes.internationalDepositPayment.path,
  privateRoutes.internationalTransferReceiptCsv.path
];

export const MT_ROUTES_FOR_SANCTIONS = [
  privateRoutes.transactionUploadSuperCsv.path,
  privateRoutes.transactionUploadBeneficiaryCsv.path,
  privateRoutes.transactionBeneficiaryList.path,
  privateRoutes.transactionMultiInput.path,
  privateRoutes.transactionReviewCsv.path,
  privateRoutes.transactionSummaryCsv.path,
  privateRoutes.transactionTransferReceiptCsv.path,
  privateRoutes.transactionTransferDeposit.path,
  privateRoutes.transactionMultiBeneficiary.path,

  // for role Approver
  privateRoutes.approval.path,
  privateRoutes.approvalReview.path,
  privateRoutes.approvalSummary.path,
  privateRoutes.approvalDeposit.path,
  privateRoutes.approvalReceipt.path,

  // Deposit
  privateRoutes.depositTopUp.path,
  privateRoutes.depositTopUpPayment.path,
  privateRoutes.depositStatement.path,

  // Refund
  privateRoutes.createRefund.path
];

export const IT_ROUTES_FOR_SANCTIONS = [
  ...FLIP_GLOBE_ROUTES,

  // Deposit
  privateRoutes.depositTopUp.path,
  privateRoutes.depositTopUpPayment.path,
  privateRoutes.depositStatement.path,

  // Refund
  privateRoutes.createRefund.path
];

export const SANDBOX_ROUTES = [
  privateRoutes.sandboxOverview.path,
  privateRoutes.sandboxTransaction.path,
  privateRoutes.sandboxTransactionMultiInput.path,
  privateRoutes.sandboxTransactionSummaryTransaction.path,
  privateRoutes.sandboxTransactionDepositPayment.path,
  privateRoutes.sandboxTransactionTransferPayment.path,
  privateRoutes.sandboxTransactionHistory.path,
  privateRoutes.sandboxTransactionHistoryDetail.path,
  privateRoutes.sandboxInternationalTransactionHistory.path,
  privateRoutes.sandboxApiSettings.path,
  privateRoutes.sandboxSnapCredentials.path,
  privateRoutes.sandboxAccountInquiryHistory.path,
  privateRoutes.sandboxAcceptPaymentOverview.path,
  privateRoutes.sandboxAcceptPaymentHistory.path,
  privateRoutes.sandboxVerificationHistory.path
];

export const VERIFICATION_ROUTES = [
  privateRoutes.verificationEmail.path,
  privateRoutes.verificationPhone.path,
  privateRoutes.verificationOTP.path,
  privateRoutes.verificationBusinessType.path,
  privateRoutes.verificationPersonalData.path,
  privateRoutes.verificationBusinessDetails.path,
  privateRoutes.verificationDocuments.path,
  privateRoutes.verificationResubmission.path
];

export const EXCLUDED_COMEBACK_ROUTES = [
  publicRoutes.login.path,
  publicRoutes.notFound.path,
  publicRoutes.maintenance.path,
  publicRoutes.expired.path,
  privateRoutes.home.path
];
